module.exports = __webpack_public_path__ + "static/media/GWS_Giants_logo.d65ec017.svg";